import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import CrownIcon from '@assets/icons/spinner/crown.svg';
import CrossIcon from '@assets/icons/spinner/cross.svg';
import style from './spinner.module.scss';

interface ISpinnerProps {
  embedded?: boolean;
  position?: boolean;
  little?: boolean;
}

export const Spinner = (props: ISpinnerProps) => {
  return (
    <>
      {props.position && <div className='w-full h-full bg-white dark:bg-soft-black opacity-70 fixed top-0 left-0 z-[1200]' />}
      <div
        className={clsx(
          'flex items-center justify-center',
          props.position && 'fixed top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] z-[1200]',
          props.embedded && 'w-full h-full bg-dark-ice-white absolute top-0 left-0',
        )}
      >
        <div
          className={clsx(
            'w-[106px] h-[106px] flex justify-center relative',
            props.embedded && '!w-full !h-full items-center',
            props.little && '!w-[80px] !h-5 items-center mt-10 mx-10 ',
          )}
        >
          <div
            className={clsx(
              'w-[106px] h-[106px] rounded-full border-t-4 border-r-4 border-b-4 border-l-4 border-t-medium-gray border-r-medium-gray border-b-medium-gray  relative',
              PaletteUtils.isInsigniaPalette && 'border-l-ecru',
              PaletteUtils.isVcfcPalette && 'border-l-primary',
              props.embedded && '!w-8 !h-8 !border-[3px]',
              props.little && '!w-[80px] !h-[80px]',
              style.spinner,
            )}
          />
          <div className={clsx('h-full flex flex-col items-center justify-center absolute', props.embedded && '!w-6 !h-6')}>
            {PaletteUtils.isInsigniaPalette && <CrownIcon />}
            {PaletteUtils.isVcfcPalette && <CrossIcon />}
          </div>
        </div>
      </div>
    </>
  );
};
